export var ThemeType;
(function (ThemeType) {
    ThemeType["LIGHT"] = "light";
    ThemeType["DARK"] = "dark";
})(ThemeType || (ThemeType = {}));
//# sourceMappingURL=theme.type.js.map